import { useMemo } from 'react';
import { useWallState } from '../../../../../../../../../stateProviders/WallStateProvider';
import { useFloorPlanState } from '../../../../../../../../../stateProviders/FloorPlanStateProvider';

export const VisibleLine = () => {

    const wallState = useWallState();
    const floorPlanState = useFloorPlanState();

    //set the color of the line based on the wall type
    const wallStyle = useMemo( () => {
        if(wallState.wallType === 'house') return 'red'
        if(wallState.wallType === 'houseAttached') return 'blue'
        if(wallState.wallType === 'railing') return 'green'
        if(wallState.wallType === 'stairs') return 'yellow'
        return 'black'
    },[wallState.wallType])

    //scale the thickness of the line based on the zoom level
    const strokeWidth = useMemo( () => {
        return 2 / floorPlanState.zoomLevel
    },[floorPlanState.zoomLevel]);

    return (
        <line 
            style={{strokeWidth,stroke:wallStyle}}
            x1={wallState.x1} 
            y1={wallState.y1} 
            x2={wallState.x2} 
            y2={wallState.y2} 
        />
    )
}